import type {TaskStatus as Status} from "@book-video-studio/contracts";
import {statusText} from "../status";

export const TaskStatus = ({status}: {status: Status}) => (
  <span className={`status status-${status}`}><i />{statusText[status]}</span>
);
